export enum PricingTextElement {
  Comment = 'Please send me a pricing sheet and detailed description of features for IPO Intelligence.',
  ContactUs = 'here',
}
